import {StyledSmall, StyledSmallError} from '@components/ui/InputHelpText/style.ts'
import {DefaultTFuncReturn} from 'i18next'

interface InputHelpTextProps {
    error?: string | DefaultTFuncReturn
    helpText?: string | DefaultTFuncReturn
}
const InputHelpText = ({error, helpText}: InputHelpTextProps) => {
    return (
        <>
            {error && <StyledSmallError>{error}</StyledSmallError>}
            {helpText && !error && <StyledSmall>{helpText}</StyledSmall>}
        </>
    )
}

export default InputHelpText

InputHelpText.displayName = 'InputHelpText'
